import { createRouter, createWebHistory } from 'vue-router';
// import Home from '../pages/IM_web.vue';


const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('../pages/IM_web.vue'),
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;
